import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Stock from "./pages/Stock";
import LotDetail from "./pages/LotDetail";
import AddStock from "./pages/AddStock";
import StockOut from "./pages/StockOut";
import Labels from "./pages/Labels";
import Settings from "./pages/Settings";
import Activity from "./pages/Activity";
import PurchaseOrders from "./pages/PurchaseOrders";
import Reports from "./pages/Reports";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#A8998A] text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Redirect users without dashboard permission away from "/"
  if (loc.pathname === "/" && user.role !== "admin") {
    const perms = user.permissions || [];
    if (!perms.includes("dashboard.view")) {
      if (perms.includes("stock.view")) return <Navigate to="/stock" replace />;
      if (perms.includes("po.view")) return <Navigate to="/po" replace />;
      if (perms.includes("stock.out")) return <Navigate to="/out" replace />;
      if (perms.includes("stock.add")) return <Navigate to="/add" replace />;
      if (perms.includes("labels.print")) return <Navigate to="/labels" replace />;
      if (perms.includes("activity.view")) return <Navigate to="/activity" replace />;
    }
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/stock" element={<Protected><Stock /></Protected>} />
          <Route path="/lot/:id" element={<Protected><LotDetail /></Protected>} />
          <Route path="/add" element={<Protected><AddStock /></Protected>} />
          <Route path="/out" element={<Protected><StockOut /></Protected>} />
          <Route path="/labels" element={<Protected><Labels /></Protected>} />
          <Route path="/po" element={<Protected><PurchaseOrders /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/activity" element={<Protected><Activity /></Protected>} />
          <Route path="/reports" element={<Protected><Reports /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
